<template>
    <div class="sp404" style="height: 100vh;">

    </div>
</template>


<script>
    export default {
        data () {
          return{
          	WxCode:"123",
          	id:"dklasjl"
          }
        },
        mounted: function() {
        	var timeer = setInterval(()=>{
        		if(document.getElementsByTagName("title")[0].innerText = "JM内务管理"){
        			window.clearInterval(timeer);
        		}else{
        			document.getElementsByTagName("title")[0].innerText = "JM内务管理"
        		}
        	},1000)
//      	this.WxCode = window.localStorage.getItem("wxCode");
//      	this.id = window.localStorage.getItem("wuId");
//      	this.$router.push("/data/wxProperty/"+"000"+'/'+this.id);
        }
    }
</script>

<style lang="scss">
    .sp404{
        background: url("../../assets/404.png") center no-repeat;
        background-size: 100% 100%;
        height: 100%;

    }
</style>



// WEBPACK FOOTER //
// src/components/dinnerMana/wxDinner0.vue